<template>
  <b-modal id="bpPopup" dialog-class="modal-style" centered hide-footer>
    <div class="bp-popup">
      <h1 class="bp-popup--tit">뷰티플래너 검색확인</h1>
      <form action="">
        <div class="row bp-popup--input-wrap mb-5">
          <div class="col-sm-3 bp-popup--itemtit">
            <label for="bpName">뷰티플래너명</label>
          </div>
          <div class="col-sm-9 bp-popup--input">
            <input
              type="text"
              v-model="searchData.name"
              id="bpName"
              class="form-control form-control-lg"
            />
          </div>
          <div class="col-sm-3 bp-popup--itemtit">
            <label for="bpPhone">핸드폰번호</label>
          </div>
          <div class="col-sm-9 bp-popup--input">
            <input
              type="number"
              v-model="searchData.mobile1"
              maxlength="3"
              id="bpPhone"
              class="form-control form-control-lg num-input"
            />
            <span class="hypen"> - </span>
            <input
              type="number"
              v-model="searchData.mobile2"
              maxlength="4"
              id="bpPhone2"
              class="form-control form-control-lg num-input"
            />
            <span class="hypen"> - </span>
            <input
              type="number"
              v-model="searchData.mobile3"
              maxlength="4"
              id="bpPhone3"
              class="form-control form-control-lg num-input"
            />
          </div>
          <div class="col-sm-3 bp-popup--itemtit">
            <label for="bpBirth">생년월일</label>
          </div>
          <div class="col-sm-9 bp-popup--input">
            <select
              name="bpBirth"
              id=""
              class="custom-select custom-select-lg"
              @change="checkIsDay"
              v-model="searchData.year"
            >
              <option value="">년</option>
              <option v-for="year in years" :key="year" :value="year">{{
                year
              }}</option>
            </select>
            <select
              name="bpBirth"
              id=""
              class="custom-select custom-select-lg"
              @change="checkIsDay"
              v-model="searchData.month"
            >
              <option value="">월</option>
              <option v-for="month in months" :key="month" :value="month">{{
                month
              }}</option>
            </select>
            <select
              name="bpBirth"
              id=""
              class="custom-select custom-select-lg"
              v-model="searchData.day"
            >
              <option value="">일</option>
              <option v-for="day in days" :key="day" :value="day">{{
                day
              }}</option>
            </select>
          </div>
        </div>
        <div class="text-center">
          <button @click.prevent="checkForm" class="bp-popup--btn">확인</button>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import { axios } from '@/utils/http';

export default {
  name: 'BpPopup',
  data() {
    return {
      years: [],
      months: [],
      searchData: {
        year: '',
        month: '',
        day: '',
        name: '',
        mobile1: '010',
        mobile2: '',
        mobile3: ''
      }
    };
  },
  mounted() {
    this.dateSetting();
  },
  methods: {
    dateSetting() {
      this.setYears();
      this.setMonth();
    },
    setYears() {
      const now = new Date();
      const limitYear = now.getFullYear() - 20;
      this.years = [];
      for (let i = limitYear; i >= 1920; i -= 1) {
        this.years.push(i.toString());
      }
    },
    setMonth() {
      for (let i = 12; i > 0; i -= 1) {
        this.months.push(i.toString());
      }
    },
    checkIsDay() {
      if (!this.days.includes(this.searchData.day)) {
        this.searchData.day = '';
      }
    },
    checkForm() {
      if (!this.searchData.name) {
        return alert('뷰티플래너명을 입력해 주세요.');
      }
      if (
        !this.searchData.mobile1 ||
        !this.searchData.mobile2 ||
        !this.searchData.mobile3
      ) {
        return alert('휴대폰 번호를 입력해 주세요.');
      }
      if (
        !this.searchData.year ||
        !this.searchData.month ||
        !this.searchData.day
      ) {
        return alert('생년월일을 선택해 주세요.');
      }
      this.checkIsBp();
    },
    async checkIsBp() {
      const params = {
        name: this.searchData.name,
        mobileNo: `${this.searchData.mobile1}${this.searchData.mobile2}${this.searchData.mobile3}`,
        birthDay: `${this.searchData.year}-${this.searchData.month.padStart(
          2,
          '0'
        )}-${this.searchData.day.padStart(2, '0')}`
      };
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_MYOFFICE_API_BASE_URL}/v1/member/distributors/beauty-planners?name=${params.name}&mobileNo=${params.mobileNo}&birthDay=${params.birthDay}`,
          {
            name: this.searchData.name,
            mobileNo: `${this.searchData.mobile1}${this.searchData.mobile2}${this.searchData.mobile3}`,
            birthDay: `${this.searchData.year}-${this.searchData.month.padStart(
              2,
              '0'
            )}-${this.searchData.day.padStart(2, '0')}`
          }
        );
        if (response.data.data) {
          alert('등록된 뷰티플래너 입니다.');
        } else {
          alert('등록된 뷰티플래너 정보가 없습니다.');
        }
      } catch (e) {
        alert('처리 중 에러가 발생하였습니다.');
      }
    }
  },
  computed: {
    days() {
      if (this.searchData.month && this.searchData.year) {
        const day = new Date(
          this.searchData.year,
          this.searchData.month,
          0
        ).getDate();
        const dayList = [];
        for (let i = day; i > 0; i -= 1) {
          dayList.push(i.toString());
        }
        return dayList;
      }
      return [];
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/bpPopup.scss';
</style>
